<style scoped>
.el-col-5 {
  width: 30%;
}
.el-col-9{
  display: flex;
}
</style>
<template>
  <div class="content">
    <div class="search-area" style="display:flex">
      <div class="t-left font-S16 mr30">流程名称：{{ this.$route.query.flowName }}</div>
      <div class="t-left font-S16">应用公司：{{ this.$route.query.tenantName }}</div>
    </div>
    <div class="search-area ">
      <div class="t-left font-S16">规则管理</div>
      <el-row :gutter="24">
        <el-col :span="9"
          ><div class="search-area-div w110">应用部门名称：</div>
          <el-input v-model="page.organisationName" class="ipt-sty" placeholder="请输入名称"></el-input
        ></el-col>
        <el-col :span="5">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">添加会议规则</el-button>
      <el-button icon="el-icon-plus" size="mini" type="info" @click="addBpmnProcess(1, '')">流程设计</el-button>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" >
      <el-table :data="treeData" style="width: 100%; margin-bottom: 20px" border v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="organisationName" label="应用部门" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="noteCount" label="审批节点个数" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="ccCount" label="抄送节点个数" header-align="center" align="left"> </el-table-column>
        <el-table-column
          prop="isMeetingCompany"
          width="150"
          label="是否会议公司管理"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.isMeetingCompany == 'N' ? '否' : '是' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" v-if="scope.row.camundaDeploymentId == null" @click="add(2, scope.row)">修改规则 | </a>
            <a class="txt-color" v-else @click="addBpmnProcess(2, scope.row)">修改规则 | </a>
            <a class="txt-color-red" @click="getDeleteData(scope.row.guid)"> 删除</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        flowTemplateGuid: '',
        staffGuid: '',
        tenantGuid: '',
        organisationName: '',
      },
      treeData: [],
      tableLoading: false,
    };
  },
  created() {
    // 列表
    this.getData(true);
  },
  activated(){
       this.getData(false);
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        flowTemplateGuid: '',
        staffGuid: '',
        tenantGuid: '',
        organisationName: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.treeData = [];
      self.page.tenantGuid = self.$route.query.tenantGuid;
      self.page.flowTemplateGuid = self.$route.query.flowTemplateGuid;
      self.tableLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/approve/data/get-flow-rule-list`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            self.treeData = res.data.data.records || [];
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows =res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    add(type, row) {
      if (type == 1) {
        var query = {
          flowTemplateGuid: this.$route.query.flowTemplateGuid,
          tenantGuid: this.$route.query.tenantGuid,
          flowName: this.$route.query.flowName,
          tenantName: this.$route.query.tenantName,
        };
        sessionStorage.removeItem('organisations');
      } else {
        var query = {
          ruleGuid: row.guid,
          flowTemplateGuid: this.$route.query.flowTemplateGuid,
          tenantGuid: this.$route.query.tenantGuid,
          flowName: this.$route.query.flowName,
          tenantName: this.$route.query.tenantName,
        };
        sessionStorage.organisations = JSON.stringify(row.organisations);
      }
      this.$router.push({
        path: '/examinerSet',
        query: query,
      });
    },
    addBpmnProcess(type, row){
      if(type == 1){
        var query = {
          flowTemplateGuid: this.$route.query.flowTemplateGuid,
          tenantGuid: this.$route.query.tenantGuid,
          flowName: this.$route.query.flowName,
          tenantName: this.$route.query.tenantName,
          productGuid:this.$route.query.productGuid
        };
      }else{
        var query = {
          flowTemplateGuid: this.$route.query.flowTemplateGuid,
          tenantGuid: this.$route.query.tenantGuid,
          flowName: this.$route.query.flowName,
          tenantName: this.$route.query.tenantName,
          productGuid:this.$route.query.productGuid,
          deploymentId: row.camundaDeploymentId
        };
      }
      this.$router.push({
        path: '/processQuery',
        query: query,
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getDeleteData(guid) {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/approve/data/delete-flow-rule?guid=` + guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>
